import { StyledComponent } from '@emotion/styled';
import { Toolbar, ToolbarProps, styled } from '@mui/material';

const minHeight = 50;

export const RightToolbar: StyledComponent<ToolbarProps> = styled(Toolbar)(({ theme }) => ({
  padding: `0 ${theme.spacing(1.5)}`,
  minHeight: minHeight,
  borderRadius: theme.shape.borderRadius,
  boxShadow: theme.shadows[3],
  '& .MuiButton-root, > .MuiIconButton-root': {
    padding: theme.spacing(0.5),
    marginRight: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5)
  },
  '& .MuiButton-root': {
    paddingLeft: theme.spacing(1.5),
    paddingRight: theme.spacing(1.5)
  },
  [theme.breakpoints.up('md')]: {
    minHeight: minHeight,
    padding: `0 ${theme.spacing(1.5)}`
  }
}));
